import { forwardRef } from 'react';

const ClickableImage = forwardRef<HTMLImageElement, any>((props, ref) => (<img role="presentation" ref={ref} alt="" {...props} />));

ClickableImage.displayName = 'ClickableImage';

export default ClickableImage;
